import picLinhTran from 'src/assets/images/team/desktop/polygon/picLinhTran.png';
import picTuanPhan from 'src/assets/images/team/desktop/polygon/picTuanPhan.png';
import picTriNguyen from 'src/assets/images/team/desktop/polygon/picTriNguyen.png';
import picDungTran from 'src/assets/images/team/desktop/polygon/picDungTran.png';
import picThaoNguyen from 'src/assets/images/team/desktop/polygon/picThaoNguyen.png';
import picThiAnhDao from 'src/assets/images/team/desktop/polygon/picThiAnhDao.png';
import picMarcusLeng from 'src/assets/images/team/desktop/polygon/picMarcusLeng.png';
import picDiepPham from 'src/assets/images/team/desktop/polygon/picDiepPham.png';
import picThanhNguyen from 'src/assets/images/team/desktop/polygon/picThanhNguyen.png';
import picHungLuong from 'src/assets/images/team/desktop/polygon/picHungLuong.png';

const teamMember = [
  {
    name: 'Mr. Tuan Phan',
    position: 'CEO - Founder',
    avatar: picTuanPhan,
    jobDesc: 'CEO Sweetlife / COO Hanofarm',
  },
  {
    name: 'Mr. Tri Nguyen',
    position: 'CTO - Founder',
    avatar: picTriNguyen,
    jobDesc: 'Co-Founder Moonka',
  },
  {
    name: 'Ms. Linh Tran',
    position: 'COO',
    avatar: picLinhTran,
    jobDesc: 'OM of Hanofarm, Sweetlife',
  },
  {
    name: 'Mr. Thanh Nguyen',
    position: 'CSO',
    avatar: picThanhNguyen,
    jobDesc: '',
  },
  {
    name: 'Mr. Marcus Leng',
    position: 'Advisor',
    avatar: picMarcusLeng,
    jobDesc: 'Co-Founder of MOC Vietnam',
  },
  {
    name: 'Ms. Thi Anh Dao',
    position: 'Advisor',
    avatar: picThiAnhDao,
    jobDesc: 'CEO Isobar Vietnam',
  },
  // {
  //   name: 'Mr. Hung Luong',
  //   position: 'Advisor',
  //   avatar: picHungLuong,
  //   jobDesc: 'Vice President VN Entrepreneurs Scientific Union',
  // },
  {
    name: 'Ms. Thao Nguyen',
    position: 'Brand Manager',
    avatar: picThaoNguyen,
    jobDesc: 'MM of 365 Begin/Sweetlife',
  },
  {
    name: 'Ms. Dung Tran',
    position: 'Art Director',
    avatar: picDungTran,
    jobDesc: 'Founder of Takidu8 Studio',
  },
  {
    name: 'Ms. Diep Pham',
    position: 'Community Manager',
    avatar: picDiepPham,
    jobDesc: 'Co-Founder of Sweetlife Ltd',
  },
];

export { teamMember };
